import QRCodeLib from "qrcode";

export class QRCode {
    static async getDataUrl(text) {
        return new Promise((resolve) => {
            QRCodeLib.toDataURL(text, { errorCorrectionLevel: 'H' }, function (err, url) {
                resolve(url);
            })
        })
    }

    static async downloadQRCodeImage(filename, text) {
        const dataURL = await QRCode.getDataUrl(text);
        const a = document.createElement('a');
        a.setAttribute("href", dataURL);
        a.setAttribute("download", filename);
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}